import { BoardContainer } from "../BoardContainer";
import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { HUD } from "./HUD";
import * as Carrom from "carrom-king-engine";
import BattleUtils from "../../../gzp/BattleUtils";
import { BootScene } from "../../BootScene";

export class PlayerAvatarContainer extends Phaser.GameObjects.Container {

    public puckIcon: Phaser.GameObjects.Image;
    public redPuckIcon: Phaser.GameObjects.Image;
    public scoreLabel: Phaser.GameObjects.Text;

    private isPlayer: boolean;
    private playerNameLabel: Phaser.GameObjects.Text;
    private pocketedPucksLabel: Phaser.GameObjects.Text;
    private timerFrame: Phaser.GameObjects.Image;
    private avatarFrame: Phaser.GameObjects.Image;
    private emoji: Phaser.GameObjects.Image;
    private balloonContainer: Phaser.GameObjects.Container;
    private pucksContainer: Phaser.GameObjects.Image;

    private hud: HUD;

    constructor(scene: Phaser.Scene, isPlayer: boolean, hud: HUD) {

        super(scene);

        this.isPlayer = isPlayer;
        this.hud = hud;

        if (BoardContainer.currentInstance.scaleX === 1) {
            this.x = this.isPlayer ? - 170 : 170;
        } else {
            this.x = this.isPlayer ? - 170 : 170;
        }

        this.y = 75;

        this.balloonContainer = new Phaser.GameObjects.Container(this.scene, 0, 0);
        this.balloonContainer.visible = false;
        this.add(this.balloonContainer);

        const balloon = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "emoji_bubble");
        balloon.setScale(.85);
        this.balloonContainer.add(balloon);

        this.emoji = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "emoji_1");
        this.emoji.setScale(.7);
        this.balloonContainer.add(this.emoji);

        this.playerNameLabel = new Phaser.GameObjects.Text(this.scene, this.isPlayer ? - 70 : 65, -40 + (BootScene.textYgap * -10), "", { fontFamily: "Teko-Medium", fontSize: "30px", color: "#FFFFFF" });
        this.playerNameLabel.setShadow(0, 3, "#061f55", 0, false, true);
        this.add(this.playerNameLabel);

        if (this.isPlayer) {
            this.playerNameLabel.setOrigin(1, BootScene.originY);
            this.playerNameLabel.text = GameVars.playerData.name;
            this.balloonContainer.x = 110;
            this.emoji.x = 8;
        } else {
            this.playerNameLabel.setOrigin(0, BootScene.originY);
            if (!BattleUtils.isBattle) {
                this.playerNameLabel.text = GameVars.adversaryData.name;
            } else {
                this.playerNameLabel.text = BattleUtils.battleOpponentData.firstName;
            }
            this.balloonContainer.x = -110;
            balloon.scaleX = -.85;
            this.emoji.x = - 8;
        }

        if (this.playerNameLabel.text.length > 14) {
            this.playerNameLabel.text = this.playerNameLabel.text.substring(0, 13) + ".";
        }

        if (this.playerNameLabel.text.length > 10) {
            this.playerNameLabel.setFontSize(27);
        }

        if (GameVars.gameMode === Carrom.GameMode.PROFESSIONAL) {

            this.scoreLabel = null;

            this.pucksContainer = new Phaser.GameObjects.Image(this.scene, 0, 90, "texture_atlas_1", "puck_container_small");
            this.pucksContainer.alpha = .35;
            this.add(this.pucksContainer);

            this.puckIcon = new Phaser.GameObjects.Image(this.scene, this.isPlayer ? 16 : -16, 90, "texture_atlas_1", "icon_puck_white");
            this.puckIcon.setScale(.95);
            this.add(this.puckIcon);

            if (this.isPlayer && GameVars.playerColor === Carrom.Color.BLACK) {
                this.puckIcon.setFrame("icon_puck_black");
            }

            if (!this.isPlayer && GameVars.adversaryColor === Carrom.Color.BLACK) {
                this.puckIcon.setFrame("icon_puck_black");
            }

            this.redPuckIcon = new Phaser.GameObjects.Image(this.scene, this.isPlayer ? 35 : -35, 90, "texture_atlas_1", "icon_puck_red");
            this.redPuckIcon.visible = false;
            this.redPuckIcon.setScale(.95);
            this.add(this.redPuckIcon);

            this.pocketedPucksLabel = new Phaser.GameObjects.Text(this.scene, this.isPlayer ? - 20 : 20, 90 + (BootScene.textYgap * -55), "0", { fontFamily: "Teko-Medium", fontSize: "38px", color: "#FFFFFF" });
            this.pocketedPucksLabel.setOrigin(.5,BootScene.originY);
            this.pocketedPucksLabel.setShadow(0, 4, "#061f55", 0, false, true);
            this.add(this.pocketedPucksLabel);

        } else {

            this.puckIcon = null;
            this.pocketedPucksLabel = null;
            this.pucksContainer = null;

            const winningScoreLabel = new Phaser.GameObjects.Text(this.scene, 0, 30 + (BootScene.textYgap * -52), "/" + GameConstants.FREESTYLE_WINNING_SCORE, { fontFamily: "Teko-Medium", fontSize: "45px", color: "#FFFFFF" });
            winningScoreLabel.setOrigin(0, BootScene.originY);
            winningScoreLabel.setShadow(0, 3, "#061f55", 0, false, true);
            this.add(winningScoreLabel);

            this.scoreLabel = new Phaser.GameObjects.Text(this.scene, 0 + (BootScene.textYgap * -15), 58 + (BootScene.textYgap * -95), "0", { fontFamily: "Teko-Medium", fontSize: "58px", color: "#FFFFFF" });
            if(BootScene._isBrave){
                this.scoreLabel.setOrigin(0.9, BootScene.originY);
            } else if (BootScene._isWebKit) {
                this.scoreLabel.setOrigin(0.9, BootScene.originY);
                
            } this.scoreLabel.setOrigin(1,1);
            this.scoreLabel.setShadow(0, 4, "#061f55", 0, false, true);
            this.add(this.scoreLabel);

            if (this.isPlayer) {

                winningScoreLabel.x = -135;
                this.scoreLabel.x = -135;

            } else {

                winningScoreLabel.x = 125;
                this.scoreLabel.x = 125;
            }
        }

        const avatar = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", this.isPlayer ? "avatar-gamezop-2" : "avatar-gamezop-3");
        this.add(avatar);
        this.loadProfilePic(avatar, isPlayer);
        this.timerFrame = new Phaser.GameObjects.Image(this.scene, 0, -3, "texture_atlas_1", "timer_1");
        this.timerFrame.visible = false;
        this.timerFrame.setScale(.8);
        this.add(this.timerFrame);

        this.avatarFrame = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "icon_basic_frame");
        this.add(this.avatarFrame);
    }

    public showEmoji(i: number): void {

        this.emoji.setFrame("emoji_" + i);

        this.balloonContainer.visible = true;
        this.balloonContainer.setScale(0);

        this.scene.add.tween({
            targets: this.balloonContainer,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250
        });

        this.scene.add.tween({
            targets: this.balloonContainer,
            scaleX: 0,
            scaleY: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 150,
            delay: 2500,
            onComplete: function (): void {
                this.balloonContainer.visible = false;
            },
            onCompleteScope: this
        });
    }

    public activate(): void {

        this.avatarFrame.setFrame("icon_frame");
        this.timerFrame.visible = true;
        this.timerFrame.setFrame("timer_1");
        this.avatarFrame.setScale(1.1);
    }

    public deactivate(): void {

        this.avatarFrame.setFrame("icon_basic_frame");
        this.timerFrame.visible = false;
        this.avatarFrame.setScale(1);
    }

    public onShot(): void {

        this.timerFrame.visible = false;
    }

    public onQueenPocketed(): void {

        this.redPuckIcon.visible = true;

        this.pocketedPucksLabel.x = this.isPlayer ? - 36 : 36;
        this.puckIcon.x = this.isPlayer ? -4 : 4,

            this.pucksContainer.setFrame("puck_container_big");
    }

    public onQueenRestituted(): void {

        setTimeout(() => {
            this.redPuckIcon.visible = false;

            this.pocketedPucksLabel.x = this.isPlayer ? - 20 : 20;
            this.puckIcon.x = this.isPlayer ? 16 : -16,

                this.pucksContainer.setFrame("puck_container_small");
        }, 2000);
    }

    public onDiskRestituted(color: string): void {

        if (this.isPlayer && GameVars.playerColor === color) {
            GameVars.playerData.pocketedPucks--;
        }

        if (!this.isPlayer && GameVars.adversaryColor === color) {
            GameVars.adversaryData.pocketedPucks--;
        }

        this.updatePocketedPucks();

    }

    public updateTimer(): void {

        if (GameVars.time >= 16) {
            this.timerFrame.setFrame("timer_16");
            return;
        }

        if (GameVars.time === 10 && GameVars.currentTurnPlayerId === GameVars.playerData.id) {
            this.hud.messageContainer.showMessage(Messages.CLOCK_TICKING);
        }

        this.timerFrame.setFrame("timer_" + GameVars.time);
    }

    public updatePocketedPucks(): void {

        if (this.isPlayer) {
            this.pocketedPucksLabel.text = GameVars.playerData.pocketedPucks.toString();
        } else {
            this.pocketedPucksLabel.text = GameVars.adversaryData.pocketedPucks.toString();
        }

        this.pocketedPucksLabel.scaleY = .825;

        this.scene.add.tween({
            targets: this.pocketedPucksLabel,
            scaleY: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 150
        });
    }

    public updateScore(): void {

        let score: number;

        if (this.isPlayer) {
            score = GameVars.playerData.score;
        } else {
            score = GameVars.adversaryData.score;
        }

        if (this.scoreLabel.text !== score.toString()) {
            this.scene.add.tween({
                targets: this.scoreLabel,
                scaleY: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 150,
                delay: 500,
                onStart: function (): void {
                    this.scoreLabel.text = score.toString();
                    this.scoreLabel.scaleY = .825;
                },
                onStartScope: this
            });
        }
    }

    private loadProfilePic(avatar: Phaser.GameObjects.Image, isPlayer: boolean) {
        if (isPlayer) {
            if (BattleUtils.battlePlayerData.photo && BattleUtils.playerProfileCache) {
                avatar.setTexture(BattleUtils.playerProfileCache);
                avatar.displayHeight = 100;
                avatar.displayWidth = 100;
            }
        } else {
            if (BattleUtils.isBattle) {
                if (BattleUtils.battleOpponentData.photo && BattleUtils.opponentProfileCache) {
                    avatar.setTexture(BattleUtils.opponentProfileCache);
                    avatar.displayHeight = 100;
                    avatar.displayWidth = 100;
                }
            }
        }
    }
}
